import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { useCreatePlanMutation } from "@modules/plans/services/mutations";
import { PlanFormValues, planSchema } from "@modules/plans/validations";
import { listPlansQueryKey } from "@modules/plans/services/queries/listPlans/query";

export function useCreatePlanModal(modalRef: RefObject<ModalRef>, onComplete?: () => void) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<PlanFormValues>({
    resolver: zodResolver(planSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreatePlanMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listPlansQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("subscription_plan_admin.success.create"),
      });

      modalRef.current?.close();
      onComplete?.();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
